import { msg } from "@lingui/core/macro";

export const creationDateIsWithinAvailabilityWindowRuleMessages = {
	name: msg({ message: "Permit Creation Date is Within Availability Window" }),
	description: msg({ message: "Permits may only be created within the availability window" }),
	errors: {
		isOutsideWindow: msg({ message: "Permits can only be created between {rangeStartISO} and {rangeEndISO}" }),
		isAfterStartOnly: msg({ message: "Permits can only be created after {rangeStartISO}" }),
		isBeforeEndOnly: msg({ message: "Permits can only be created before {rangeEndISO}" }),
	},
} as const;
